/**
 * Copyright 2019-2026 ForgeRock AS. All Rights Reserved
 *
 * Use of this code requires a commercial software license with ForgeRock AS
 * or with one of its affiliates. All use shall be exclusively subject
 * to such license between the licensee and ForgeRock AS.
 */

import { DEPLOYMENT_TYPES } from '@forgerock/platform-shared/src/constants/deploymentConstants';
import IDMRouter from './deployment/idm/router';
import PlatformRouter from './deployment/platform/router';

const DEPLOYMENT_TYPE = process.env.VUE_APP_DEPLOYMENT_TYPE;

let initializeRouter;

switch (DEPLOYMENT_TYPE) {
  case DEPLOYMENT_TYPES.IDM:
    initializeRouter = IDMRouter;
    break;
  case DEPLOYMENT_TYPES.PLATFORM:
  default:
    initializeRouter = PlatformRouter;
}

const router = initializeRouter();

export default router;
